
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { FileText, Briefcase, GraduationCap } from 'lucide-react';

interface ProfileCompletionCardProps {
  profileCompletion: number;
}

const ProfileCompletionCard: React.FC<ProfileCompletionCardProps> = ({ profileCompletion }) => {
  return (
    <Card className="border border-[#0EA5E9]/20 shadow-md bg-white/80">
      <CardHeader>
        <CardTitle>Profile Completion</CardTitle>
        <CardDescription>
          Complete your profile to increase visibility to recruiters
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Progress</span>
          <span className="text-[#0EA5E9] font-semibold">{profileCompletion}%</span>
        </div>
        <Progress value={profileCompletion} className="bg-gray-100 h-2" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
          <Link to="/job-seeker-profile">
            <Button variant="secondary" className="w-full border border-[#0EA5E9]/30 flex justify-start gap-2 bg-[#F0F9FF] text-[#0EA5E9]">
              <FileText className="text-[#0EA5E9]" />
              <span>Add Resume</span>
            </Button>
          </Link>
          <Link to="/job-seeker-profile?tab=experience" className="w-full">
            <Button variant="secondary" className="w-full border border-[#0EA5E9]/30 flex justify-start gap-2 bg-[#F0F9FF] text-[#0EA5E9]">
              <Briefcase className="text-[#0EA5E9]" />
              <span>Work Experience</span>
            </Button>
          </Link>
          <Link to="/job-seeker-profile?tab=education" className="w-full">
            <Button variant="secondary" className="w-full border border-[#0EA5E9]/30 flex justify-start gap-2 bg-[#F0F9FF] text-[#0EA5E9]">
              <GraduationCap className="text-[#0EA5E9]" />
              <span>Education</span>
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileCompletionCard;
